export default __webpack_public_path__ + "static/media/expertise_s.cefa82e9.jpg";